<template>
  <div>
<!--    <div class="toggle-button" @click="stretch">-->
<!--      <i v-if="this.$store.state.menuCollapse" class="el-icon-s-unfold"></i>-->
<!--      <i v-else class="el-icon-s-fold"></i>-->
<!--    </div>-->
    <el-menu
        :collapse="this.$store.state.menuCollapse"
        class="el-menu-vertical-demo"
        active-text-color="#45B7E2"
        text-color="#878789"
        :collapse-transition="false"
        :default-active="curActive"
        background-color="#f9fafc">
      <template v-for="menu in menuTree">
        <el-submenu v-if="menu.istype===0 && menu.children && menu.children.length>0" :index="menu.code">
          <template slot="title">
            <i :class="menu.icon"></i>
            <span slot="title">{{ menu.name }}</span>
          </template>
          <template v-if="menu.children && menu.children.length>0">
            <el-menu-item v-for="childMenu in menu.children" :index="childMenu.page" @click="menuClick(childMenu)">{{ childMenu.name }}</el-menu-item>
          </template>
        </el-submenu>
        <el-menu-item v-else :index="menu.page" @click="menuClick(menu)">
          <i :class="menu.icon"></i>
          <span slot="title">{{ menu.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import commonUtil from "@/util/commonUtil";

export default {
  name: "Aside",
  data() {
    return {
      curActive: "/system/user",
      menuTree: []
    }
  },
  methods: {
    stretch() {
      this.$store.commit("CHANGE_MENU_COLLAPSE");
    },
    menuClick(menu){
      this.$store.commit("ADD_IFRAME_TABS",menu)
    }
  },
  created() {
    this.$axios.post('/permission/permissionList').then(res => {
      this.menuTree = commonUtil.toPermissionTree(res.data.data);
    })
    this.curActive = this.$route.path;
  }
}
</script>

<style scoped lang="less">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  min-height: 400px;
}
.el-menu{
  border-right:0;
}
.el-menu-item {
  font-family:fzlt_zh;
}
/deep/.el-submenu__title {
  font-family:fzlt_zh;
}

.toggle-button{
  font-size:10px;
  line-height:24px;
  text-align: center;
  letter-spacing: 0.2em;
  cursor:pointer;
  border-bottom: solid 1px #e6e6e6;
}
</style>